"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitValues = void 0;
const omitValues = (source, valuesToOmit) => {
    const valuesToOmitSet = new Set(valuesToOmit);
    const result = {};
    for (const key in source) {
        if (!valuesToOmitSet.has(source[key])) {
            result[key] = source[key];
        }
    }
    return result;
};
exports.omitValues = omitValues;
//# sourceMappingURL=omitValues.js.map